module.exports = __webpack_public_path__ + "img/Refresh report.1d191867.svg";